import { Routes } from "@angular/router";

import { environment } from "src/environments/environment";

import { appEnvironmentGuard } from "./guards/app-environment-guard";
import { AppName } from "./types/environment.type";
import { ROUTE_PATH } from "./types/route.type";
import { getEnvironmentRedirectRoute } from "./helpers/helper-route.util";

const getActiveAppRoutes = (): Routes => {
  const activeApp = (environment.app || '').toLowerCase();
  const routesList: Routes = [
    {
      path: ROUTE_PATH.Global,
      loadChildren: () => import("./pages/global/global.routes").then(m => m.routes),
      data: { preload: true }
    }
  ];

  switch (activeApp) {
    case AppName.Admin:
      routesList.push({
        path: ROUTE_PATH.UserAdmin,
        loadChildren: () => import("./pages/user-admin/user-admin.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Admin)],
        data: { preload: true }
      });
      break;
    case AppName.Consumer:
      routesList.push({
        path: ROUTE_PATH.UserConsumer,
        loadChildren: () => import("./pages/user-consumer/user-consumer.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Consumer)],
        data: { preload: true }
      });
      break;
    case AppName.Merchant:
      routesList.push({
        path: ROUTE_PATH.UserMerchant,
        loadChildren: () => import("./pages/user-merchant/user-merchant.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Merchant)],
        data: { preload: true }
      });
      break;
    case AppName.Staff:
      routesList.push({
        path: ROUTE_PATH.UserStaff,
        loadChildren: () => import("./pages/user-staff/user-staff.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Staff)],
        data: { preload: true }
      });
      break;
    case AppName.Supplier:
      routesList.push({
        path: ROUTE_PATH.UserSupplier,
        loadChildren: () => import("./pages/user-supplier/user-supplier.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Supplier)],
        data: { preload: true }
      });
      break;
    case AppName.Site:
    default:
      routesList.push({
        path: ROUTE_PATH.PublicSite,
        loadChildren: () => import("./pages/public-site/public-site.routes").then(m => m.routes),
        canActivate: [appEnvironmentGuard(AppName.Site)],
        data: { preload: true }
      });
      break;
  }

  return routesList;
};

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: getEnvironmentRedirectRoute,
  },
  ...getActiveAppRoutes(),
  {
    path: '**',
    redirectTo: getEnvironmentRedirectRoute,
    pathMatch: 'full'
  }
];